import { currencyFormat } from '@fiverr-private/localization';
import { PricingDetails } from '../../../type';
import { useIsDiscountPage } from '../../hooks';

interface UseSubscriptionPriceArgs {
    pricingDetails?: PricingDetails;
    licensesQuantity: number;
}

export const useSubscriptionSummarizePrice = ({ pricingDetails, licensesQuantity }: UseSubscriptionPriceArgs) => {
    const isDiscountPage = useIsDiscountPage();

    if (!pricingDetails?.price) {
        return {
            singularPlanPrice: null,
            totalPrice: null,
        };
    }

    const { discountedAmountMonthly, discountedAmountYearly, amountMonthly, amountYearly, currency } =
        pricingDetails.price;

    const selectedMonthlyAmount = isDiscountPage ? discountedAmountMonthly : amountMonthly;
    const selectedYearlyAmount = isDiscountPage ? discountedAmountYearly : amountYearly;

    const singularPlanPrice = selectedMonthlyAmount
        ? currencyFormat({
              value: selectedMonthlyAmount,
              currencyCode: currency,
              options: { maximumFractionDigits: 2 },
          })
        : null;

    const totalPrice = selectedYearlyAmount
        ? currencyFormat({
              value: selectedYearlyAmount * Math.abs(licensesQuantity),
              currencyCode: currency,
              options: { maximumFractionDigits: 2 },
          })
        : null;

    return {
        singularPlanPrice,
        totalPrice,
    };
};
